<template>
  <!--My Account -->
  <div>
    <v-container class="account_vue">
      <v-layout row>
        <v-flex xs12 sm12>
          <v-card>
            <v-card-text>
              <v-container>
                <h1>Profiilisivu</h1>
                  <br>
                  <router-link to="/account">Profiili </router-link> &nbsp;&nbsp;       
                  <router-link to="/edit-account">Muokkaa Profiilia </router-link>&nbsp;&nbsp;             
                  <router-link to="/order-history">Tilaushistoria</router-link>&nbsp;&nbsp;          
                  <router-link to="/account-settings">Asetukset</router-link>
                  <br><br>
                  <v-layout row>
                    <v-flex xs12>
                        <b>Nimi:</b> {{this.account.name}}
                    </v-flex>
                  </v-layout>
                  <br>
                  <v-layout row>
                    <v-flex xs12>
                        <b>Sähköposti:</b> {{this.email}}
                    </v-flex>
                  </v-layout>
                  <br>
                  <v-layout row>
                    <v-flex xs12>
                        <b>Puhelinnumero:</b> {{this.account.phone}}
                    </v-flex>
                  </v-layout>
                  <br>
                  <v-layout row>
                    <v-flex xs12>
                        <b>Osoite:</b> {{this.account.address}}
                    </v-flex>
                  </v-layout>
                  <br>
                  <v-layout row>
                    <v-flex xs12>
                        <b>Kaupunki:</b> {{this.account.city}}
                    </v-flex>
                  </v-layout>
                  <br>
                  <v-layout row>
                    <v-flex xs12>
                        <b>Maa:</b> {{this.account.country}}
                    </v-flex>
                  </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
     
<script>
  import firebase from "firebase";   
  export default {
  data(){
    return{
      userId:null, 
      name:null,           
      email:null,
      password:null,               
      cart:this.$store.getters.cart,    
      userLoggedin:null,
      account:[]            
    }
  },
  methods:{
      
  },
  created(){
    // Current User
    var user = firebase.auth().currentUser;
    if (user) {
        this.userId = user.uid            
        this.email = user.email            
        this.userLoggedin = true;                
    } else {
        this.userLoggedin = false;            
    }
    // User Profile Information
    var db = firebase.firestore();
    db.collection("profiles").doc(this.userId).onSnapshot(doc =>{
      this.account = doc.data()          
    })
  },   
  }
</script>
  
<style scoped>
  a{
    text-decoration: underline;  
    color:#345B2C; 
  }
  .account_vue{
    height:75.5vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/account/Account.vue